module.exports = "/images/menu.svg";